import React from 'react'
import BooksList from '../pure/booksList'

function booksListContainer({data}) {

    return (
      <div id='tableContainer' className="d-flex flex-row flex-wrap gap-3">
          < BooksList data={data}/>
      </div>
    )
  
}

export default booksListContainer